import { spanFromRegExpMatch } from '../spans';
import type { ExtractorOutput } from './types';

export function extractRental(query: string): ExtractorOutput {
  const rentPattern = /\b(?:for\s+rent|rentals?|leases?|to\s+lease|to\s+rent)\b/gi;
  const rentMatch = rentPattern.exec(query);
  if (rentMatch) {
    return {
      partial: { rental: true },
      spans: [
        spanFromRegExpMatch(query, rentMatch, 'rental', true, {
          confidence: 0.95,
          ruleId: 'rental.true',
        }),
      ],
    };
  }

  const salePattern = /\b(?:for\s+sale|to\s+buy|to\s+purchase)\b/gi;
  const saleMatch = salePattern.exec(query);
  if (saleMatch) {
    return {
      partial: { rental: false },
      spans: [
        spanFromRegExpMatch(query, saleMatch, 'rental', false, {
          confidence: 0.95,
          ruleId: 'rental.false',
        }),
      ],
    };
  }

  return { partial: {}, spans: [] };
}

/**
 * Listing status aligned to Filter Search: Active → available, Sold, Expired, Pending.
 * Sold wins when multiple status words appear.
 */
export function extractStatus(query: string): ExtractorOutput {
  const soldPattern = /\b(?:sold|recently\s+sold)\b/gi;
  const soldMatch = soldPattern.exec(query);
  if (soldMatch) {
    return {
      partial: { status: 'not-available-sold' },
      spans: [
        spanFromRegExpMatch(query, soldMatch, 'status', 'not-available-sold', {
          confidence: 0.9,
          ruleId: 'status.sold',
        }),
      ],
    };
  }

  const expiredPattern = /\bexpired(?:\s+listings?)?\b/gi;
  const expiredMatch = expiredPattern.exec(query);
  if (expiredMatch) {
    return {
      partial: { status: 'expired' },
      spans: [
        spanFromRegExpMatch(query, expiredMatch, 'status', 'expired', {
          confidence: 0.9,
          ruleId: 'status.expired',
        }),
      ],
    };
  }

  const pendingPattern = /\bpending(?:\s+listings?)?\b/gi;
  const pendingMatch = pendingPattern.exec(query);
  if (pendingMatch) {
    return {
      partial: { status: 'pending' },
      spans: [
        spanFromRegExpMatch(query, pendingMatch, 'status', 'pending', {
          confidence: 0.9,
          ruleId: 'status.pending',
        }),
      ],
    };
  }

  const availablePattern = /\b(?:available|active\s+listings?|listings?\s+that\s+are\s+active)\b/gi;
  const availableMatch = availablePattern.exec(query);
  if (availableMatch) {
    return {
      partial: { status: 'available' },
      spans: [
        spanFromRegExpMatch(query, availableMatch, 'status', 'available', {
          confidence: 0.85,
          ruleId: 'status.available',
        }),
      ],
    };
  }

  return { partial: {}, spans: [] };
}
